import React, { useEffect, useState } from 'react';

import { useBeraJobStepsContext } from '../context';

const DEBOUNCE_DELAY = 1000;
const DEFAULT_PAGE_SIZE = 10;
const SEARCH_PAGE_SIZE = 100;
const FIRST_PAGE = 1;

interface UseFileSearchResult {
	isSearchingFile: boolean;
	handleSearchFileNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function useFileSearch(): UseFileSearchResult {
	const [timer, setTimer] = useState<NodeJS.Timeout>();
	const [isSearchingFile, setIsSearchingFile] = useState<boolean>(false);

	const { fileName, handlePageChange, handleFileNameChange, handleSizeChange } = useBeraJobStepsContext();

	useEffect(() => {
		setIsSearchingFile(false);
	}, [fileName]);

	function setFileName(name: string): void {
		clearTimeout(timer);

		const debounce = setTimeout(() => {
			if (!name || name.length === 0) {
				handleSizeChange(DEFAULT_PAGE_SIZE);
			} else {
				handlePageChange(FIRST_PAGE);
				handleSizeChange(SEARCH_PAGE_SIZE);
			}
			handleFileNameChange(name);
		}, DEBOUNCE_DELAY);

		setTimer(debounce);
	}

	function handleSearchFileNameChange(event: React.ChangeEvent<HTMLInputElement>): void {
		const { value } = event.target;

		setIsSearchingFile(true);
		setFileName(value);
	}

	return { isSearchingFile, handleSearchFileNameChange };
}
